import { EegUserPageFilters, ReportStatus } from '../types';

export const serializeEegLabUserNeurorefTableParams = (
  search: string | null,
  filters: EegUserPageFilters,
  sortFields: {
    created_at: string;
    is_archived: boolean;
  }
) => {
  const res = [];
  if (search) {
    res.push(`search=${search}`);
  }
  if (filters.approved) {
    res.push(`status=${ReportStatus.APPROVED}`);
  }
  if (filters.rejected) {
    res.push(`status=${ReportStatus.REJECTED}`);
  }
  if (filters.delayed) {
    res.push(`status=${ReportStatus.DELAYED}`);
  }
  if (filters.readyForReview) {
    res.push(`status=${ReportStatus.READY_FOR_REVIEW}`);
  }
  if (filters.brokenNeurorefReport) {
    res.push(`status=${ReportStatus.BROKEN}`);
  }
  if (sortFields.created_at) {
    res.push(`sort=${sortFields.created_at}`);
  }
  res.push(`is_archived=${sortFields.is_archived}`);
  filters.organizations.forEach((org) => {
    res.push(`org_id=${org.value}`);
  });
  return res.join('&');
};
